import Chart from 'react-apexcharts'
import { useEffect, useState } from 'react'
import { Button, Drawer, Space } from 'antd'

interface IPROP {
  chartData: any
  uniqueValue: any
  identifier: any
  rowValues: any
  getTableRow: any
  statistics: any
}

const HorizontalBar: React.FC<IPROP> = ({
  chartData,
  uniqueValue,
  identifier,
  rowValues,
  getTableRow,
  statistics
}) => {
  const barChartValues = chartData?.find((el: any) => el.column === identifier)?.top_10_values

  const data = barChartValues?.map((value: any) => parseFloat(value.percentage).toFixed(2))

  const labels = barChartValues?.map((value: any) => value.value)

  const [drawerVisible, setDrawerVisible] = useState(false)
  const [nullValues, setNullValues] = useState<any>(null)
  const [valueUnique, setValueUnique] = useState<any>(null)
  const [statsValue, setStatsValue] = useState<any>(null)
  const [chartRendered, setChartRendered] = useState(false) // State to manage chart rendering

  const handleOpenDrawer = () => {
    setDrawerVisible(true)
    console.log()

    setTimeout(() => {
      setChartRendered(true) // Ensure chart renders after drawer is opened
    }, 100) // Delay rendering by 100ms
  }

  const handleCloseDrawer = () => {
    setDrawerVisible(false)
    setChartRendered(false) // Reset the chart render state when closing
  }

  const value = statistics && statistics[identifier]
  console.log(value, 'value')
  console.log(statistics, 'valueSt')
  console.log(identifier, 'valueI')

  useEffect(() => {
    if (rowValues && Object.keys(rowValues)?.includes(identifier)) {
      const nullValueForIdentify = rowValues[identifier]
      setNullValues(nullValueForIdentify)
    }
  }, [identifier, rowValues])

  useEffect(() => {
    if (uniqueValue && Object.keys(uniqueValue)?.includes(identifier)) {
      const uniqueValueForIdentify = uniqueValue[identifier]
      setValueUnique(uniqueValueForIdentify)
    }
  }, [identifier, uniqueValue])

  useEffect(() => {
    if (statistics && Object.keys(statistics)?.includes(identifier)) {
      const statsValueForIdentify = statistics[identifier]
      setStatsValue(statsValueForIdentify)
    }
  }, [identifier, statistics])

  console.log(statsValue, 'statsValue')
  return (
    <div className='app'>
      <div className='row'>
        <div className='mixed-chart' onClick={handleOpenDrawer}>
          <Chart
            options={{
              chart: {
                id: 'basic-bar',
                type: 'bar',
                height: 'auto',
                toolbar: {
                  show: false
                }
              },
              plotOptions: {
                bar: {
                  horizontal: false
                }
              },
              yaxis: {
                labels: {
                  show: false
                }
              },
              xaxis: {
                labels: {
                  show: false
                }
              },
              legend: {
                show: false
              },
              dataLabels: {
                enabled: false
              }
            }}
            series={[
              {
                name: 'Series 1',
                data: data || []
              }
            ]}
            type='bar'
            height='120px'
          />
        </div>
      </div>
      <Drawer
        title={identifier}
        width={500}
        onClose={handleCloseDrawer}
        open={drawerVisible}
        extra={
          <Space>
            <Button onClick={handleCloseDrawer}>X</Button>
          </Space>
        }
      >
        <div style={{ display: 'flex', width: '100%' }}>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px solid hsl(240, 17.4%, 91%)',
              margin: '0px',
              width: '33%',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Rows</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{getTableRow}</span>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <>
              <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Empty Rows</span>
              <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{nullValues}</span>
            </>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Unique Values</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{valueUnique}</span>
          </p>
        </div>
        {chartRendered && (
          <div style={{ display: 'flex', width: '100%' }}>
            <p
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                border: '1px solid hsl(240, 17.4%, 91%)',
                margin: '0px',
                width: '33%',
                padding: '16px'
              }}
            >
              <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Average</span>
              <span
                className='text-center fw-bold'
                style={{ fontSize: '15px', color: 'hsl(240, 46.3%, 8%)' }}
              >
                {statsValue?.average}
              </span>
            </p>
            <p
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '0px',
                width: '33%',
                border: '1px solid hsl(240, 17.4%, 91%)',
                padding: '16px'
              }}
            >
              <>
                <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Max</span>
                <span
                  className='text-center fw-bold'
                  style={{ fontSize: '15px', color: 'hsl(240, 46.3%, 8%)' }}
                >
                  {statsValue?.max}
                </span>
              </>
            </p>
            <p
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '0px',
                width: '33%',
                border: '1px solid hsl(240, 17.4%, 91%)',
                padding: '16px'
              }}
            >
              <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Min</span>
              <span
                className='text-center fw-bold'
                style={{ fontSize: '15px', color: 'hsl(240, 46.3%, 8%)' }}
              >
                {statsValue?.min}
              </span>
            </p>
          </div>
        )}
        {chartRendered && (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '40%'
            }}
          >
            <Chart
              options={{
                chart: {
                  id: 'basic-bar',
                  type: 'bar',
                  height: 'auto',
                  toolbar: {
                    show: false
                  },
                  offsetX: -3
                },
                plotOptions: {
                  bar: {
                    horizontal: false
                  }
                },
                xaxis: {
                  categories: labels
                },
                legend: {
                  show: false
                },
                dataLabels: {
                  enabled: false
                }
              }}
              series={[
                {
                  name: 'Values',
                  data: data || []
                }
              ]}
              type='bar'
              height='300px'
              width='100%'
            />
          </div>
        )}
      </Drawer>
    </div>
  )
}

export default HorizontalBar
